import React, { Suspense } from 'react';
import ReactDOM  from 'react-dom';
import { BrowserRouter, useHistory } from 'react-router-dom';
import Client from './Client';
import App from './App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthenticationProvider } from './components/Authentication/AuthenticationProvider'
import { Loading } from './components/Utilities/Loading'
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');


ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Client>
            <AuthenticationProvider>
                <App />
            </AuthenticationProvider>
        </Client>
    </BrowserRouter>,
  rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
